export default {
    'nav': {
        'concept': 'Concept',
        'live_course': 'Live Course',
        'online_course': 'Online Course',
        'workbook_course': 'Workbook Course',
        'summary_app': 'Summary App',
        'textbook': 'Minto Textbook',
        'barbara_minto': 'Barbara Minto',
        'contact': 'Contact'
    }
}


// WEBPACK FOOTER //
// ./client/app/components/nav/i18n/es.js